import {
  ApiConfigData,
  ApiConfigResponse,
  ApiConfigUpdateRequest,
  ApiConfigUpdateResponse,
  CreateClientSecretResponse,
  CreateNewClientRequest,
  getRequestConfig,
  withMakeRequest
} from '~/api';
import Request from '~/api/Request.ts';

const getClientCredentials: (request?: {
  includePlainSecret?: boolean;
}) => Promise<ApiConfigData[]> = withMakeRequest(
  async ({ includePlainSecret } = {}) =>
    await Request.getInstance().get(
      `/clients${includePlainSecret ? '?include_plain_secret=true' : ''}`,
      getRequestConfig({ addEnvDomain: true })
    ),
  (data: ApiConfigResponse) => data.clients
);

const getClientCredentialByClientId: (request: {
  clientId: string;
}) => Promise<ApiConfigData> = withMakeRequest(
  async (request: { clientId: string }) =>
    await Request.getInstance().get(
      `/clients/${request.clientId}`,
      getRequestConfig({ addEnvDomain: true })
    ),
  (data) => data.client
);

const updateClientCredentials: (
  clientId: string,
  data: ApiConfigUpdateRequest
) => Promise<ApiConfigUpdateResponse> = withMakeRequest(
  async (clientId, data) =>
    await Request.getInstance().patch(
      `/clients/${clientId}`,
      data,
      getRequestConfig({ addEnvDomain: true })
    )
);

const generateNewClientSecret: (
  clientId: string
) => Promise<CreateClientSecretResponse> = withMakeRequest(
  async (clientId) =>
    await Request.getInstance().post(
      `/clients/${clientId}/secrets`,
      {},
      getRequestConfig({ addEnvDomain: true })
    )
);

const deleteClientSecret: (
  clientId: string,
  secretId: string
) => Promise<CreateClientSecretResponse> = withMakeRequest(
  async (clientId, secretId) =>
    await Request.getInstance().delete(
      `/clients/${clientId}/secrets/${secretId}`,
      getRequestConfig({ addEnvDomain: true })
    )
);

const createClientForEnvironment: (
  request: CreateNewClientRequest
) => Promise<ApiConfigData> = withMakeRequest(
  async (request: CreateNewClientRequest) =>
    await Request.getInstance().post(
      `/clients`,
      request,
      getRequestConfig({ addEnvDomain: true })
    ),
  (data) => data.client
);

export {
  deleteClientSecret,
  generateNewClientSecret,
  updateClientCredentials,
  getClientCredentialByClientId,
  getClientCredentials,
  createClientForEnvironment
};
